/**
 * SeriesSequence — renders a sequence of items (letters, numbers, mixed).
 *
 * data: { items: ["A", "C", "E", "G", "?"] }
 *
 * Each item is a string. "?" renders as a mystery cell.
 */

export default function SeriesSequence({ data }) {
    // Accept both { items: ["A","C","E"] } and { item: "A" } for single
    const items = data?.items || (data?.item ? [data.item] : null);
    if (!Array.isArray(items) || items.length === 0) return null;

    return (
        <div className="qv-series">
            {items.map((item, i) => {
                const isMystery = item === '?';
                return (
                    <div key={i} className={`qv-series__item ${isMystery ? 'qv-series__item--mystery' : ''}`}>
                        <span>{item}</span>
                    </div>
                );
            })}
        </div>
    );
}
